module.exports = __webpack_public_path__ + "img/eric_biel_ocular-2.ea9d9a04.jpg";